"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.togglesReducerBase = void 0;
var tslib_1 = require("tslib");
var setOverflow = function (hidden) {
    if (hidden === void 0) { hidden = false; }
    if (document && document.body) {
        if (hidden) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'initial';
        }
    }
};
var togglesReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === 'TOGGLE') {
        var toggles = action.toggles;
        var nextState = tslib_1.__assign(tslib_1.__assign({}, state), toggles);
        setOverflow(!!nextState.showModal);
        return nextState;
    }
    if (action.type === 'LOCATION_CHANGE') {
        return null;
    }
    return state || null;
};
exports.togglesReducerBase = togglesReducerBase;
